import React from 'react';
import { Container, Grid, Paper } from '@mui/material';
import ReportHeader from 'components/featured/Reports/ReportHeader';
import PowerBIEmbed from 'components/featured/Reports/PowerBIEmbed';

const ReportsPage = () => {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper sx={{ p: 1, mb: 1 }}>
          <Grid container spacing={3}>
            <Grid size={12}> 
              <PowerBIEmbed reportName="Report 1 - Client, Lead, Deal" />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  };

export default ReportsPage;